import {
  styled,
  Box as MuiBox,
  Stack as MuiStack,
  outlinedInputClasses,
} from "@mui/material";

export const Box = styled(MuiBox)(
  ({ theme }) => `
  &.select-doctor-container {
    font-size: 13px;
    width: 350px;

    .doctor-dropdown {
      margin-top: 10px;
      border: solid 1px ${theme.palette.layout.line};
      & .${outlinedInputClasses.root} {
        padding: 0 !important;
      }
    }
  }
`
);

export const Stack = styled(MuiStack)``;
